<template>
  <ap-button
    :type="$attrs?.type ?? 'primary'"
    @click="handleClickButton"
    :size="$attrs?.size ?? 'large'"
    :class="`font-semibold leading-3 rounded`">
    <span class="text-sm"> {{ label || buttonLabel }}</span>
  </ap-button>
</template>

<script setup>
import { computed, onMounted } from "vue"
import { useI18n } from "vue-i18n"
import { useAppStore } from "@/stores/app"
import { useRouter } from "vue-router"
import ShowModalUpgradeToProHandler from "@/handlers/App/ShowUpgradeModalHandler.js"
import OpenSupportChatHandler from "@/handlers/OpenSupportChatHandler"
import useAccountChecker from "@/composables/accountChecker"

const props = defineProps({
  label: {
    type: String,
    default: () => undefined
  },
  redirect: {
    type: String,
    default: () => undefined
  }
})

defineOptions({
  inheritAttrs: true
})

const { t } = useI18n()
const router = useRouter()
const appStore = useAppStore()
const { accountSubscriptionIsDemo } = useAccountChecker()

const buttonLabel = computed(() => {
  return accountSubscriptionIsDemo.value
    ? t("component.button.contact.label")
    : t("navigation.usage.upgrade.btn")
})

function handleClickButton() {
  if (accountSubscriptionIsDemo.value) OpenSupportChatHandler.apply()
  else if (props.redirect) router.push({ name: props.redirect })
  else ShowModalUpgradeToProHandler.apply()
}

onMounted(appStore.loadPlans)
</script>
